import { BuildFontString } from "../utils/BuildFontString";
import { Div2Floor } from "../utils/Div2Floor";
import { enumElementDrawStates, kOCNDarkGrayColor } from "../constants";
import { QButton } from "./QButton";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { SetCtxFont } from "../utils/SetCtxFont.js";

export class QPlus10Button extends QButton {
  constructor() {
    super();
  }

  DoRenderContent(drawBuffer) {
    var strokeColor = kOCNDarkGrayColor;
    switch (this.GetDrawState()) {
      case enumElementDrawStates.Disabled:
        strokeColor = "#777777";
        break;
    }

    var ctx = drawBuffer.getContext("2d");
    ctx.strokeStyle = strokeColor;
    ctx.lineCap = "square";
    var thickness = 2;
    ctx.lineWidth = thickness;

    var w = this.GetWidth();
    var h = this.GetHeight();
    var lLen = 6;
    var hOffset = 6;
    var vOffset = 8;

    var sx = this.fHorzOffset + hOffset - Div2Floor(lLen) + ThicknessAdjuster(thickness); //Math.floor(lLen/2)
    var sy = this.fVertOffset + vOffset + ThicknessAdjuster(thickness);
    var ex = sx + lLen;
    var ey = sy;

    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(ex, ey);
    ctx.stroke();

    sx = this.fHorzOffset + hOffset + ThicknessAdjuster(thickness);
    sy = this.fVertOffset + vOffset - Div2Floor(lLen) + ThicknessAdjuster(thickness); //Math.floor(lLen/2)
    ex = sx;
    ey = sy + lLen;

    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(ex, ey);
    ctx.stroke();

    ctx.fillStyle = "#000000";
    var fontStr = BuildFontString("Verdana", 9, true, false);
    SetCtxFont(ctx, fontStr);
    //	ctx.font=fontStr;
    var txt = "10";
    var txtHOffset = this.fHorzOffset + 7;
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";
    var txtVOffset = this.fVertOffset + 16;
    ctx.fillText(txt, txtHOffset, txtVOffset);
  }
}
